<template>
    <div class="optionPayment"
         :style="{borderLeftColor: parceiro ? parceiroConfig.estilo.corPrimaria : 'var(primaryColor)'}"
    >
        <div style="display: flex; align-items: center">
            <div v-if="typePayment != 'cartao'">
                <h5 v-if="parcela.pra_quantidade === 0" class="titleOption">
                    R$ {{money2(parcela.valor_total)}} à vista {{(parcela.valorFuturoIncluso)? ' (incluso lançamento futuro de R$'+ money2(parcela.valorFuturoTotal)+ ')':''}}
                </h5>
                <h5 v-else-if="parcela.valor_entrada" class="titleOption">
                    {{parcela.valor_entrada ? `Entrada de R$ ${(parcela.valor_entrada)} +` : '' }}
                    {{`(${parcela.pra_quantidade}x de R$ ${(parcela.valor_parcela)})`}}
                    {{(parcela.valorFuturoIncluso)? ' (incluso valor lançamento futuro de R$'+ money2(parcela.valorFuturoTotal)+ ')':''}}
                </h5>
                <h5 v-else class="titleOption">
                    {{`${parcela.pra_quantidade}x de R$ ${(parcela.valor_parcela)}`}}
                    {{(parcela.valorFuturoIncluso)? ' (incluso valor lançamento futuro de R$'+ money2(parcela.valorFuturoTotal)+ ')':''}}
                </h5>
                <h5 class="subTitleOption">
                    Vencimento em {{parcela.pra_primeiro_vcto.split('-').join('/')}}
                </h5>
            </div>
            <div v-else-if="typePayment === 'cartao'">
                <h5 class="titleOption">
                    {{`${parcela.parcelamento}x de R$ ${parcela.valor_parcela}`}}
                </h5>
                <h5 class="subTitleOption">
                    Valor total: R$ {{money2(parcela.valor_total)}}
                </h5>
            </div>
        </div>
        <i style="font-size: 24px;"
           :style="{color: parceiro ? parceiroConfig.estilo.corPrimaria : 'var(primaryColor)'}"
           class="fas fa-chevron-right"
        />
    </div>
</template>

<script>
    import globalMethods from "../../../../mixins/globalMethods";
    import {mapState} from "vuex";

    export default {
        name: "MonthlyPaymentCard",
        mixins:[globalMethods],
        props:[
            'parcela',
            'typePayment',
        ],
        computed:{
            ...mapState({
                showMessageModal: state => state.messageModal.show,
                parceiro: state => state.parceiro,
                parceiroConfig: state => state.parceiroConfig,
            })
        },
    }
</script>

<style scoped>
    .optionPayment{
        box-sizing: border-box;
        width: 100%;
        height: 90px;
        display: flex;
        align-items: center;
        padding: 0 20px;
        border-bottom: 1px solid #fafafa;
        border-top: 1px solid #fafafa;
        border-right: 1px solid #fafafa;
        cursor: pointer;
        border-radius: 10px;
        justify-content: space-between;
        border-left: 7px solid var(--primaryColor);
        margin: 15px 0;
        box-shadow: 0 1px 2px rgba(3,27,78,0.16);
    }

    .optionPayment:hover{
        background: var(--opacityGrayColor);
    }

    .icon-box{
        width: 45px;
        height: 45px;
        border-radius: 10px;
        background: var(--primaryColor);
        margin-right: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .icon-box i{
        color: #ffffff;
        font-size: 14px;
        margin: 0;
    }

    .titleOption{
        color: #031b4e;
        font-family: "Roboto Black";
        font-size: 16px;
        margin-bottom: 5px;
    }

    .subTitleOption{
        color: #5b6987;
        font-family: "Roboto";
        font-size: 12px;
    }
</style>
